/* Daily Bible verse — v1.0.0
   Picks a verse by the visitor's date, so it changes every day automatically.
   Fills every element with [data-daily-verse]. Verses: King James Version (public domain). */
(function () {
  if (window.DailyVerse) {
    window.DailyVerse.fill();
    return;
  }
  var VERSES = [
    [
    "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.",
    "John 3:16"
    ],
    [
    "The LORD is my shepherd; I shall not want.",
    "Psalm 23:1"
    ],
    [
    "I can do all things through Christ which strengtheneth me.",
    "Philippians 4:13"
    ],
    [
    "Trust in the LORD with all thine heart; and lean not unto thine own understanding.",
    "Proverbs 3:5"
    ],
    [
    "In all thy ways acknowledge him, and he shall direct thy paths.",
    "Proverbs 3:6"
    ],
    [
    "And we know that all things work together for good to them that love God, to them who are the called according to his purpose.",
    "Romans 8:28"
    ],
    [
    "Be still, and know that I am God.",
    "Psalm 46:10"
    ],
    [
    "Thy word is a lamp unto my feet, and a light unto my path.",
    "Psalm 119:105"
    ],
    [
    "Come unto me, all ye that labour and are heavy laden, and I will give you rest.",
    "Matthew 11:28"
    ],
    [
    "Jesus saith unto him, I am the way, the truth, and the life: no man cometh unto the Father, but by me.",
    "John 14:6"
    ],
    [
    "Peace I leave with you, my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be afraid.",
    "John 14:27"
    ],
    [
    "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee.",
    "Isaiah 41:10"
    ],
    [
    "But they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.",
    "Isaiah 40:31"
    ],
    [
    "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.",
    "Jeremiah 29:11"
    ],
    [
    "The LORD bless thee, and keep thee.",
    "Numbers 6:24"
    ],
    [
    "Have not I commanded thee? Be strong and of a good courage; be not afraid, neither be thou dismayed: for the LORD thy God is with thee whithersoever thou goest.",
    "Joshua 1:9"
    ],
    [
    "This is the day which the LORD hath made; we will rejoice and be glad in it.",
    "Psalm 118:24"
    ],
    [
    "Delight thyself also in the LORD; and he shall give thee the desires of thine heart.",
    "Psalm 37:4"
    ],
    [
    "Commit thy way unto the LORD; trust also in him; and he shall bring it to pass.",
    "Psalm 37:5"
    ],
    [
    "God is our refuge and strength, a very present help in trouble.",
    "Psalm 46:1"
    ],
    [
    "The LORD is my light and my salvation; whom shall I fear? the LORD is the strength of my life; of whom shall I be afraid?",
    "Psalm 27:1"
    ],
    [
    "Create in me a clean heart, O God; and renew a right spirit within me.",
    "Psalm 51:10"
    ],
    [
    "O give thanks unto the LORD; for he is good: for his mercy endureth for ever.",
    "Psalm 136:1"
    ],
    [
    "Bless the LORD, O my soul, and forget not all his benefits.",
    "Psalm 103:2"
    ],
    [
    "I will lift up mine eyes unto the hills, from whence cometh my help. My help cometh from the LORD, which made heaven and earth.",
    "Psalm 121:1-2"
    ],
    [
    "Thy word have I hid in mine heart, that I might not sin against thee.",
    "Psalm 119:11"
    ],
    [
    "The fear of the LORD is the beginning of wisdom: and the knowledge of the holy is understanding.",
    "Proverbs 9:10"
    ],
    [
    "A soft answer turneth away wrath: but grievous words stir up anger.",
    "Proverbs 15:1"
    ],
    [
    "Train up a child in the way he should go: and when he is old, he will not depart from it.",
    "Proverbs 22:6"
    ],
    [
    "The name of the LORD is a strong tower: the righteous runneth into it, and is safe.",
    "Proverbs 18:10"
    ],
    [
    "Keep thy heart with all diligence; for out of it are the issues of life.",
    "Proverbs 4:23"
    ],
    [
    "To every thing there is a season, and a time to every purpose under the heaven.",
    "Ecclesiastes 3:1"
    ],
    [
    "Remember now thy Creator in the days of thy youth.",
    "Ecclesiastes 12:1"
    ],
    [
    "Thou wilt keep him in perfect peace, whose mind is stayed on thee: because he trusteth in thee.",
    "Isaiah 26:3"
    ],
    [
    "But he was wounded for our transgressions, he was bruised for our iniquities: the chastisement of our peace was upon him; and with his stripes we are healed.",
    "Isaiah 53:5"
    ],
    [
    "For unto us a child is born, unto us a son is given: and the government shall be upon his shoulder: and his name shall be called Wonderful, Counsellor, The mighty God, The everlasting Father, The Prince of Peace.",
    "Isaiah 9:6"
    ],
    [
    "The grass withereth, the flower fadeth: but the word of our God shall stand for ever.",
    "Isaiah 40:8"
    ],
    [
    "It is of the LORD's mercies that we are not consumed, because his compassions fail not. They are new every morning: great is thy faithfulness.",
    "Lamentations 3:22-23"
    ],
    [
    "He hath shewed thee, O man, what is good; and what doth the LORD require of thee, but to do justly, and to love mercy, and to walk humbly with thy God?",
    "Micah 6:8"
    ],
    [
    "The LORD thy God in the midst of thee is mighty; he will save, he will rejoice over thee with joy.",
    "Zephaniah 3:17"
    ],
    [
    "Not by might, nor by power, but by my spirit, saith the LORD of hosts.",
    "Zechariah 4:6"
    ],
    [
    "Blessed are the pure in heart: for they shall see God.",
    "Matthew 5:8"
    ],
    [
    "Blessed are the peacemakers: for they shall be called the children of God.",
    "Matthew 5:9"
    ],
    [
    "Ye are the light of the world. A city that is set on an hill cannot be hid.",
    "Matthew 5:14"
    ],
    [
    "Let your light so shine before men, that they may see your good works, and glorify your Father which is in heaven.",
    "Matthew 5:16"
    ],
    [
    "But seek ye first the kingdom of God, and his righteousness; and all these things shall be added unto you.",
    "Matthew 6:33"
    ],
    [
    "Ask, and it shall be given you; seek, and ye shall find; knock, and it shall be opened unto you.",
    "Matthew 7:7"
    ],
    [
    "Take my yoke upon you, and learn of me; for I am meek and lowly in heart: and ye shall find rest unto your souls.",
    "Matthew 11:29"
    ],
    [
    "For where two or three are gathered together in my name, there am I in the midst of them.",
    "Matthew 18:20"
    ],
    [
    "Thou shalt love the Lord thy God with all thy heart, and with all thy soul, and with all thy mind.",
    "Matthew 22:37"
    ],
    [
    "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost.",
    "Matthew 28:19"
    ],
    [
    "And, lo, I am with you alway, even unto the end of the world. Amen.",
    "Matthew 28:20"
    ],
    [
    "For with God nothing shall be impossible.",
    "Luke 1:37"
    ],
    [
    "Glory to God in the highest, and on earth peace, good will toward men.",
    "Luke 2:14"
    ],
    [
    "In the beginning was the Word, and the Word was with God, and the Word was God.",
    "John 1:1"
    ],
    [
    "And the Word was made flesh, and dwelt among us, (and we beheld his glory, the glory as of the only begotten of the Father,) full of grace and truth.",
    "John 1:14"
    ],
    [
    "I am the bread of life: he that cometh to me shall never hunger; and he that believeth on me shall never thirst.",
    "John 6:35"
    ],
    [
    "I am the light of the world: he that followeth me shall not walk in darkness, but shall have the light of life.",
    "John 8:12"
    ],
    [
    "And ye shall know the truth, and the truth shall make you free.",
    "John 8:32"
    ],
    [
    "I am come that they might have life, and that they might have it more abundantly.",
    "John 10:10"
    ],
    [
    "I am the good shepherd: the good shepherd giveth his life for the sheep.",
    "John 10:11"
    ],
    [
    "I am the resurrection, and the life: he that believeth in me, though he were dead, yet shall he live.",
    "John 11:25"
    ],
    [
    "A new commandment I give unto you, That ye love one another; as I have loved you, that ye also love one another.",
    "John 13:34"
    ],
    [
    "Let not your heart be troubled: ye believe in God, believe also in me.",
    "John 14:1"
    ],
    [
    "I am the vine, ye are the branches: He that abideth in me, and I in him, the same bringeth forth much fruit: for without me ye can do nothing.",
    "John 15:5"
    ],
    [
    "Greater love hath no man than this, that a man lay down his life for his friends.",
    "John 15:13"
    ],
    [
    "These things I have spoken unto you, that in me ye might have peace. In the world ye shall have tribulation: but be of good cheer; I have overcome the world.",
    "John 16:33"
    ],
    [
    "For I am not ashamed of the gospel of Christ: for it is the power of God unto salvation to every one that believeth.",
    "Romans 1:16"
    ],
    [
    "For all have sinned, and come short of the glory of God.",
    "Romans 3:23"
    ],
    [
    "But God commendeth his love toward us, in that, while we were yet sinners, Christ died for us.",
    "Romans 5:8"
    ],
    [
    "For the wages of sin is death; but the gift of God is eternal life through Jesus Christ our Lord.",
    "Romans 6:23"
    ],
    [
    "There is therefore now no condemnation to them which are in Christ Jesus, who walk not after the flesh, but after the Spirit.",
    "Romans 8:1"
    ],
    [
    "What shall we then say to these things? If God be for us, who can be against us?",
    "Romans 8:31"
    ],
    [
    "So then faith cometh by hearing, and hearing by the word of God.",
    "Romans 10:17"
    ],
    [
    "And be not conformed to this world: but be ye transformed by the renewing of your mind.",
    "Romans 12:2"
    ],
    [
    "Rejoicing in hope; patient in tribulation; continuing instant in prayer.",
    "Romans 12:12"
    ],
    [
    "Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, through the power of the Holy Ghost.",
    "Romans 15:13"
    ],
    [
    "Charity suffereth long, and is kind; charity envieth not; charity vaunteth not itself, is not puffed up.",
    "1 Corinthians 13:4"
    ],
    [
    "And now abideth faith, hope, charity, these three; but the greatest of these is charity.",
    "1 Corinthians 13:13"
    ],
    [
    "Let all your things be done with charity.",
    "1 Corinthians 16:14"
    ],
    [
    "Therefore if any man be in Christ, he is a new creature: old things are passed away; behold, all things are become new.",
    "2 Corinthians 5:17"
    ],
    [
    "For we walk by faith, not by sight.",
    "2 Corinthians 5:7"
    ],
    [
    "My grace is sufficient for thee: for my strength is made perfect in weakness.",
    "2 Corinthians 12:9"
    ],
    [
    "I am crucified with Christ: nevertheless I live; yet not I, but Christ liveth in me.",
    "Galatians 2:20"
    ],
    [
    "But the fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance.",
    "Galatians 5:22-23"
    ],
    [
    "And let us not be weary in well doing: for in due season we shall reap, if we faint not.",
    "Galatians 6:9"
    ],
    [
    "For by grace are ye saved through faith; and that not of yourselves: it is the gift of God.",
    "Ephesians 2:8"
    ],
    [
    "And be ye kind one to another, tenderhearted, forgiving one another, even as God for Christ's sake hath forgiven you.",
    "Ephesians 4:32"
    ],
    [
    "Finally, my brethren, be strong in the Lord, and in the power of his might.",
    "Ephesians 6:10"
    ],
    [
    "Being confident of this very thing, that he which hath begun a good work in you will perform it until the day of Jesus Christ.",
    "Philippians 1:6"
    ],
    [
    "Rejoice in the Lord alway: and again I say, Rejoice.",
    "Philippians 4:4"
    ],
    [
    "Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God.",
    "Philippians 4:6"
    ],
    [
    "And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.",
    "Philippians 4:7"
    ],
    [
    "But my God shall supply all your need according to his riches in glory by Christ Jesus.",
    "Philippians 4:19"
    ],
    [
    "Set your affection on things above, not on things on the earth.",
    "Colossians 3:2"
    ],
    [
    "And whatsoever ye do, do it heartily, as to the Lord, and not unto men.",
    "Colossians 3:23"
    ],
    [
    "Rejoice evermore. Pray without ceasing. In every thing give thanks: for this is the will of God in Christ Jesus concerning you.",
    "1 Thessalonians 5:16-18"
    ],
    [
    "For God hath not given us the spirit of fear; but of power, and of love, and of a sound mind.",
    "2 Timothy 1:7"
    ],
    [
    "All scripture is given by inspiration of God, and is profitable for doctrine, for reproof, for correction, for instruction in righteousness.",
    "2 Timothy 3:16"
    ],
    [
    "For the word of God is quick, and powerful, and sharper than any twoedged sword.",
    "Hebrews 4:12"
    ],
    [
    "Let us therefore come boldly unto the throne of grace, that we may obtain mercy, and find grace to help in time of need.",
    "Hebrews 4:16"
    ],
    [
    "Now faith is the substance of things hoped for, the evidence of things not seen.",
    "Hebrews 11:1"
    ],
    [
    "But without faith it is impossible to please him: for he that cometh to God must believe that he is, and that he is a rewarder of them that diligently seek him.",
    "Hebrews 11:6"
    ],
    [
    "Looking unto Jesus the author and finisher of our faith.",
    "Hebrews 12:2"
    ],
    [
    "Jesus Christ the same yesterday, and to day, and for ever.",
    "Hebrews 13:8"
    ],
    [
    "If any of you lack wisdom, let him ask of God, that giveth to all men liberally, and upbraideth not; and it shall be given him.",
    "James 1:5"
    ],
    [
    "But be ye doers of the word, and not hearers only, deceiving your own selves.",
    "James 1:22"
    ],
    [
    "Draw nigh to God, and he will draw nigh to you.",
    "James 4:8"
    ],
    [
    "Humble yourselves in the sight of the Lord, and he shall lift you up.",
    "James 4:10"
    ],
    [
    "Casting all your care upon him; for he careth for you.",
    "1 Peter 5:7"
    ],
    [
    "If we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.",
    "1 John 1:9"
    ],
    [
    "Beloved, let us love one another: for love is of God; and every one that loveth is born of God, and knoweth God.",
    "1 John 4:7"
    ],
    [
    "We love him, because he first loved us.",
    "1 John 4:19"
    ],
    [
    "Behold, I stand at the door, and knock: if any man hear my voice, and open the door, I will come in to him, and will sup with him, and he with me.",
    "Revelation 3:20"
    ],
    [
    "And God shall wipe away all tears from their eyes; and there shall be no more death, neither sorrow, nor crying, neither shall there be any more pain.",
    "Revelation 21:4"
    ],
    [
    "In the beginning God created the heaven and the earth.",
    "Genesis 1:1"
    ],
    [
    "Be strong and of a good courage, fear not, nor be afraid of them: for the LORD thy God, he it is that doth go with thee; he will not fail thee, nor forsake thee.",
    "Deuteronomy 31:6"
    ],
    [
    "But as for me and my house, we will serve the LORD.",
    "Joshua 24:15"
    ],
    [
    "The joy of the LORD is your strength.",
    "Nehemiah 8:10"
    ],
    [
    "O taste and see that the LORD is good: blessed is the man that trusteth in him.",
    "Psalm 34:8"
    ],
    [
    "Cast thy burden upon the LORD, and he shall sustain thee.",
    "Psalm 55:22"
    ],
    [
    "He that dwelleth in the secret place of the most High shall abide under the shadow of the Almighty.",
    "Psalm 91:1"
    ],
    [
    "Make a joyful noise unto the LORD, all ye lands.",
    "Psalm 100:1"
    ],
    [
    "Enter into his gates with thanksgiving, and into his courts with praise: be thankful unto him, and bless his name.",
    "Psalm 100:4"
    ],
    [
    "Let every thing that hath breath praise the LORD. Praise ye the LORD.",
    "Psalm 150:6"
    ],
    [
    "He healeth the broken in heart, and bindeth up their wounds.",
    "Psalm 147:3"
    ],
    [
    "Search me, O God, and know my heart: try me, and know my thoughts.",
    "Psalm 139:23"
    ],
    [
    "I will praise thee; for I am fearfully and wonderfully made.",
    "Psalm 139:14"
    ]
    ];

  function dayNumber() {
    var now = new Date();
    return Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000);
  }

  function pick(list) {
    return list[dayNumber() % list.length];
  }

  function fill(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-daily-verse]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var list = VERSES;
      var custom = el.getAttribute('data-dv-custom');
      if (custom) {
        try {
          var parsed = JSON.parse(custom);
          if (parsed && parsed.length) list = parsed;
        } catch (e) {}
      }
      var verse = pick(list);
      var text = el.querySelector('[data-dv-text]');
      var ref = el.querySelector('[data-dv-ref]');
      if (text) text.textContent = verse[0];
      if (ref) ref.textContent = verse[1] + (el.getAttribute('data-dv-version') ? ' ' + el.getAttribute('data-dv-version') : '');
      el.classList.add('is-ready');
    }
  }

  window.DailyVerse = { fill: fill, verses: VERSES };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fill(); });
  } else {
    fill();
  }
  document.addEventListener('shopify:section:load', function (e) { fill(e.target); });
})();